module.exports = {
  DAILY_LOOTCOINS: 150,
  RECRUITED_FRIEND: 500,
  COMIC_READ: 350,
  BUNDLE_BOUGHT: 2000,
  SHRED_CARD: 100,
  SHRED_REWARD_CARD: 10,
  WATCHED_AD: 100,
  FACEBOOK_PAGE_LIKED: 1000,
};
